import m from "../../geodata/es2015/omanHigh";
window.am4geodata_omanHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/omanHigh.js
// module id = null
// module chunks = 